<!-- 群发月度统计-群发数据统计面 -->
<template>
<div id="send-box">
	<div style="background-color: #fff;padding: 15px 15px 5px;margin-bottom: 15px;">
		<!-- 标题 -->
		<div class="page-title" style="margin-bottom: 10px;">群发数据统计</div>
		
		<div style="display: flex;align-items: flex-start;">
			<div style="flex: 1;">
				<a-row type="flex" justify="start" style="align-items: center;">
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">月份</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-range-picker
								      :placeholder="['开始月份', '结束月份']"
								      format="YYYY-MM"
								      :mode="['month', 'month']"
								      @change="onChangeMonth"
									  @panelChange="onPanelMonth"
									  style="width: 100%;"
									  :value="startTime"
									  :allowClear="false"
								    />
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">渠道</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
								mode="multiple"
									show-search
									allowClear
								    style="width: 100%;"
								    placeholder="请选择渠道"
								    @change="handleChangeB"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
								  >
								    <a-select-option v-for="(value,key) in selectData.channel" :key="key" :value="key" :title="value">
								      {{value}}
								    </a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">公众号组</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
								mode="multiple"
									show-search
									allowClear
									notFoundContent="← 请先选择: 渠道" 
								    style="width: 100%;"
								    placeholder="请选择公众号组"
								    @change="handleChangeC"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
								  >
								    <a-select-option v-for="(value,key) in gzhSelectGroup" :key="key" :value="key">
								      {{value}}
								    </a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">公众号</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<!-- <a-select
									show-search
									allowClear
									notFoundContent="← 请先选择: 公众号组" 
								    style="width: 100%;"
								    placeholder="请选择公众号"
								    @change="handleChangeD"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
								  >
								    <a-select-option v-for="(item,index) in gzhSelect" :key="item.id" :value="item.id">
								      {{item.gzh_name}}
								    </a-select-option>
								</a-select> -->
								
								<gzhSearchMoreSelect ref="getGzhSelect" s_width="100%" @openGzhSelect="handleChangeD"></gzhSearchMoreSelect>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">运营</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
								mode="multiple"
									show-search
									allowClear
								    style="width: 100%;"
								    placeholder="请选择运营"
								    @change="handleChangeY"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
								  >
								    <a-select-option v-for="(value,key) in selectData.user" :key="key" :value="key" :title="value">
								      {{value}}
								    </a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
					
					<a-col :span="6" class="a-col-content-margin">
						<a-row type="flex" align="middle">
							<a-col :span="col_left_span" class="a-col-left-label">设置群发次数</a-col>
							<a-col :span="col_content_span" class="a-col-right-padding">
								<a-select
									show-search
									allowClear
								    style="width: 100%;"
								    placeholder="请选择设置群发次数"
								    @change="handleChangeE"
									:filter-option="filterOption"
									:getPopupContainer="getsPopupContainer"
								  >
								    <a-select-option value="lt">设置不足4次</a-select-option>
									<a-select-option value="lgt">设置4次及以上</a-select-option>
								</a-select>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</div>
			<div style="width: 95px;border-left: 1px solid #e5e6eb;padding-left: 12px;">
				<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="margin-bottom-15" style="margin-right: 15px;">搜索</a-button>
			</div>
		</div>
	</div>
	
	<div style="background-color: #fff;padding: 15px 15px 30px;">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<!-- <div class="table-th-cell"
				:style="{'width':check_width + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div> -->
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index " class="table-th-cell"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
				<!-- 选择 -->
				<!-- <div class="table-td-cell" :style="{'width':check_width + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div> -->
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'gzh_groups'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'gzh_groups'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="display: flex;flex-wrap: wrap;">
					<div v-for="(item_z,index) in item[z_tem.type]" :key="index" style="display: block;margin-right: 7px;margin-bottom: 3px;">
						<a-tag>{{item_z}}</a-tag>
					</div>
				</div>					
			</template>
		</div>
		<!-- <div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #f2f3f5;height: calc(100vh - 65px);width: 20px;"></div> -->
		<!-- <div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #f2f3f5;height: calc(100vh - 65px);width: 20px;"></div> -->
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import gzhSearchMoreSelect from '@/components/selectCompont/searchSelect.vue'

import { opeGzhSelect, gzhGroupGet, gzhMonthlyList, getGzhGroup } from '@/request/api'
export default {
	name: 'sendMonthlyStatistics_',
	components: {
		gzhSearchMoreSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			
			startTime: [],
			
			col_left_span: 7,
			col_content_span: 17, 
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"渠道", width:100, type:"channel_name", },
				{title:"公众号组", width:150, type:"gzh_groups", },
				{title:"公众号", width:130, type:"gzh_name", },
				{title:"月份", width:100, type:"month", },
				{title:"设置群发次数", width:100, type:"draft_send_set", },
				{title:"已群发次数", width:100, type:"draft_send_success", },
				{title:"待群发次数", width:100, type:"draft_send_ing", },
				{title:"可设置次数", width:100, type:"can_draft_send", },
				{title:"运营",width:100, type:"gzh_user", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			sticky_index: 0,
			
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_channel_id: [], // 渠道id
			r_group_id: [], // 公众号组ID
			r_gzh_id: null, // 公众号id
			r_admin_id: [], // 运营人员
			r_draft_send_set: null, // 设置群发次数 不足4次=lt，大于4ci=lgt
			
			selectData: [],
			gzhSelectGroup: {}, // 公众号组
			gzhSelect: [], // 公众号
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let body_width = document.body.clientWidth - 40 - 30 - 200 // 筛选条件大盒子的宽度
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		let table_width = 0
		// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
		if(nn < body_width && body_width - nn > 50){ // 当表格内容不足以沾满一屏时，要适配成一屏
			// console.log("适配")
			that.rableTitle.forEach(res=>{ // 针对表格每一项的宽度进行适配
				res.width = Math.round((res.width/nn)*(body_width)) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
			})
			table_width = body_width
		}
		else { // 表格宽度大于等于屏幕可视宽度
			// console.log("不适配")
			table_width = nn
		}
		that.table_scroll_width = table_width
		that.table_null_width = table_width
		
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let date_arr = []
		date_arr.push(this.moment(date2.getFullYear() + "-" + month2, "YYYY-MM"))
		date_arr.push(this.moment(date2.getFullYear() + "-" + month2, "YYYY-MM"))
		console.log("date_arr",date_arr);
		that.startTime = date_arr
		
		opeGzhSelect().then(res=>{
			console.log("下拉",res);
			that.selectData = res.data.data
		})
		
		that.searchButton()
		
		that.$nextTick(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		})
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		onChangeMonth(date, dateString){
			console.log(date, dateString);
			this.startTime = dateString
		},
		onPanelMonth(value, mode){
			console.log(value);
			this.startTime = value
		},
		handleChangeB(e){
			console.log(e);
			let that = this
			that.r_channel_id = e
			// gzhGroupGet({
			// 	channel_id: e,
			// }).then(res=>{
			// 	console.log("获取渠道下对应分组和未分组",res)
			// 	if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
			// 		that.gzhSelectGroup = res.data.data.list
			// 	}
			// 	else {
			// 		that.$message.error(`错误：${res.data.msg}`);
			// 	}
			// })
			// 获取公众号组
			getGzhGroup({
				channel_id: e,
			}).then(res=>{
				console.log("公众号组",res)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.gzhSelectGroup = res.data.data.list
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
			
			// 获取公众号
			that.$refs.getGzhSelect.getfilterGzh(that.r_channel_id)
		},
		handleChangeC(e){ // 公众号组
			console.log(e);
			let that = this
			
			that.r_group_id = e
			
			for (let key in that.gzhSelectGroup) {
				if(key == e){
					that.gzhSelect = that.gzhSelectGroup[key]
					console.log("that.gzhSelect",that.gzhSelect);
					return
				}
			}
		},
		handleChangeD(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeY(e){ // 请选择运营
			console.log(e);
			this.r_admin_id = e
		},
		handleChangeE(e){ // 设置群发次数
			console.log(e);
			this.r_draft_send_set = e
		},
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){ // 除开分页以外的请求都要把选中状态清空
				that.r_page = 1
			}
			let r_data = {
				// channel_id: e,
				page: that.r_page,
				limit: that.r_limit,
				
				channel_id: that.r_channel_id, // 渠道id
				group_id: that.r_group_id, // 公众号组ID
				gzh_id: that.r_gzh_id, // 公众号id
				admin_id: that.r_admin_id, // 运营人员
				draft_send_set: that.r_draft_send_set, // 设置群发次数 不足4次=lt，大于4ci=lgt
			}
			// console.log("moment(that.startTime[0]).format('YYYY-MM')",moment(that.startTime[0]).format('YYYY-MM'));
			r_data.start_month =  moment(that.startTime[0]).format('YYYY-MM').replace(/-/g, '')
			r_data.end_month = moment(that.startTime[1]).format('YYYY-MM').replace(/-/g, '')
			gzhMonthlyList(r_data).then(res=>{
				console.log("公众号统计页面",res);
				that.search_button_loading = false
				that.table_total = res.data.data.total || 0
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					let data = res.data.data.data
					that.tableShowData = data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
	}
}
</script>

<style scoped>
#send-box {
	background-color: rgb(240, 242, 245);
	margin: -20px -30px -30px -20px;
	padding: 20px 20px 30px 20px;
	min-height: calc(100vh - 65px);
}

.table-th-cell-sticky,.table-td-cell-sticky {
	left: 20px;
}
</style>